import Vue from 'vue';
import VueI18n from 'vue-i18n'
import Axios from 'axios'
import ModuleNotAvailable from './../apps/ModuleNotAvailable';
import app from '../app';

export default {

    container: 'app',

    apps: [],

    language: 'no',

    currentApp: null,

    appsLoaded: [],

    run(path, config, language) {

        this.apps = config.apps;

        this.language = language;

        this.log("Brandsafe App Loader initiated")

        let app = this.getApp(path)

        if (app === null) {

            this.log('App not found: "' + path + '"')
            this.createContainer({ container: 'app' }, (app) => {
                this._moduleNotAvailable('fa-exclamation-circle', 'module_not_available.title', 'module_not_available.text');

            });

            //document.getElementById('app-not-found').hidden = false

            return false
        } else if (app.hasOwnProperty('enabled') && !app.enabled) { // Module not enabled

            this.createContainer(app, (app) => {
                this._moduleNotAvailable('fa-eye-slash', 'module_not_enabled.title', 'module_not_enabled.text');
            });

            return true
        }

        this.createContainer(app, (app) => {
            if (!this.hasElement(this.container)) {

                this.error('ERROR: "' + this.container + '" container not found');

                return false;
            }

            try{
                if (window.AppBridge) window.AppBridge.destroyAll();
            }catch{
                //
            }

            document.getElementById('app-not-found').hidden = true

            this.log('Loading app "' + app.route + '# to DOM element: "' + this.container + '"')

            this.loadJs(app)

            this.loadCss(app)

            this.currentApp = app

            this.appsLoaded.push(app)
        });
    },

    createContainer(app, fn) {

        if (app.hasOwnProperty('container') && app.container !== '') {

            this.container = app.container
        }

        this.log('creating container: "' + this.container + '"')

        document.getElementById('front-app-container').innerHTML = '<div id="' + this.container + '"></div>'

        return fn(app)
    },

    _moduleNotAvailable(icon, title, text) {
        let self = this;

        Vue.use(VueI18n);

        Axios.get('https://modules.brandsafe.no/translations/wrapper/' + this.language + '.json').then((response) => {

            let messages = {};

            messages[self.language] = response.data;


            const i18n = new VueI18n({
                locale: self.language, // set locale
                messages, // set locale messages
            })

            new Vue({
                i18n,
                render: h => h(ModuleNotAvailable),
                data: {
                    icon: icon,
                    title: title,
                    text: text
                }

            }).$mount('#' + self.container);
        });
    },

    loadJs(app) {

        let self = this

        if (app.url !== undefined) {

            this.writeScriptTag(app.url)

            return true
        }

        if (Array.isArray(app.js)) {
            app.js.map(function (url) {
                self.log('Injecting js:' + url)

                self.writeScriptTag(url)
            })
        }
    },

    loadCss(app) {
        let self = this

        if (app.css === undefined) {
            return false
        }

        if (Array.isArray(app.css)) {
            app.css.map(function (url) {
                self.log('Injecting css:' + url)
                self.writeLinkTag(url)
            })
        }
    },

    hasElement(id) {
        return document.getElementById(id) !== null
    },

    writeScriptTag(url) {
        let script = document.createElement('script')
        script.setAttribute('src', url)
        script.async = true
        script.defer = true
        document.head.appendChild(script)
    },

    writeLinkTag(url) {
        let link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = url;

        document.head.appendChild(link);
    },

    getApp(path) {

        if (path === null) { // Stop recursion triggered when reducing the path
            return null;
        }

        if (this.apps.length === 1) { // only one app available, load it
            return this.apps[0];
        }


        //console.log('PATH: ' + path);

        if (path === '/module-not-available') {
            return {
                'route': '/module-not-available',
                'container': 'app'
            };
        }

        if (path === '' || path === '/') {
            path = '/dashboard';
        }

        if (path.slice(-1) === '/') {
            path = path.slice(0, -1)
        }

        let app = this._getApp(path, this.apps);

        if (app === null) {
            // Recursive function which reduces the hash bang with one segment to see if the url matches one of the available apps
            return this.getApp(this._reducePath(path), this.apps);
        }

        return app;
    },

    _getApp(path, apps) {
        let self = this;

        return apps.reduce((carry, app) => {
            if (app.route === path) {
                return app
            }

            if (app.hasOwnProperty('sub_menus')) {
                let found = self._getApp(path, app.sub_menus);

                if (found !== null) {
                    return found;
                }
            }

            return carry;
        }, null)
    },

    _reducePath(path) {

        let parts = path.split('#');

        let hashbangs = parts.length > 1 ? parts[1].split('/') : [];

        if (hashbangs.length <= 0) {
            return null;
        }

        hashbangs.pop();

        path = hashbangs.join('/');

        return parts[0] + ((path.length > 0) ? ('#' + path) : '');
    },

    log(data) {
        if (process.env.VUE_APP_ENV === 'development') {
            console.log(data)
        }
    },

    isAppAlreadyLoaded(appId) {
        const loadedApp = this.appsLoaded.find(app => app.title === appId)

        return typeof loadedApp !== 'undefined'
    },

    loadSubApp(appId, force = false) {
        const self = this

        // console.log(`loading sub app >>> ${appId}`)

        if (!appId || !force && self.isAppAlreadyLoaded(appId)) {
            return false;
        }

        // check if app exists in config
        const app = self.apps.find(_app => {
            return _app['title'] === appId;
        })

        // only those apps are loaded which are not supposed to be in navigation
        if (typeof app === 'undefined' || app['show'] !== false) {
            return false;
        }

        self.loadCss(app)
        setTimeout(() => {
            self.loadJs(app)
        }, 1000)

        this.appsLoaded.push(app)

        return true;
    },

}
